import React, { Fragment, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Grid, Button, Tab } from '@material-ui/core';
import { TabPanel, TabList, TabContext } from '@material-ui/lab';

import {
  LoadingSpinner,
  PlatformMerchantOrderWithOrderItemsDetails,
  PlatformProducerOrderWithProductionPlanDetails
} from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';

interface IProps {}

const PlatformProducerWithPlatformMerchantOrderDetails: React.FC<IProps> = ({}: IProps) => {
  const [tabValue, setTabValue] = useState('platformMerchantOrder');
  const handleTabChange = (event: any, newValue: string) => {
    setTabValue(newValue);
  };

  const {
    platformProducerOrderId,
    platformMerchantOrderId
  } = PlatformNavigation.platformProducerWithPlatformMerchantOrderDetails.paramsFromPath(useRouteMatch());

  const {
    data: platformProducerOrdersData,
    loading: platformProducerOrdersLoading
  } = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrder({
    platformProducerOrderId: platformProducerOrderId
  });

  const {
    data: platformProducerProductionPlanData,
    loading: platformProducerProductionLoading
  } = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrderProductionPlanByPlatformProducerOrderId({
    platformProducerOrderId: platformProducerOrderId
  });

  const {
    data: platformMerchantOrderData,
    loading: platformMerchantOrderLoading
  } = GQLOperationBuilder.merchant.getPlatformMerchantOrder({
    orderId: platformMerchantOrderId
  });

  if (platformProducerOrdersLoading || platformProducerProductionLoading || platformMerchantOrderLoading)
    return <LoadingSpinner />;

  return (
    <Fragment>
      <TabContext value={tabValue}>
        <TabList onChange={(event, tabIndex) => handleTabChange(event, tabIndex)} aria-label="orders-tabs">
          <Tab label={`Merchant -> Platform`} value={'platformMerchantOrder'} />
          <Tab label={`Platform -> Producer`} value={'platformProducerOrder'} />
        </TabList>
        <TabPanel value={`platformMerchantOrder`}>
          <PlatformMerchantOrderWithOrderItemsDetails
            order={GQLOperationBuilder.merchant.platformMerchantOrderFromResponse(platformMerchantOrderData)}
          />
        </TabPanel>
        <TabPanel value={`platformProducerOrder`}>
          <PlatformProducerOrderWithProductionPlanDetails
            order={GQLOperationBuilder.deliveryUnit.platformProducerOrderFromResponse(
              platformProducerOrdersData
            )}
            productionPlan={GQLOperationBuilder.deliveryUnit.platformProducerOrderProductionPlanFromResponse(
              platformProducerProductionPlanData
            )}
          />
        </TabPanel>
      </TabContext>
    </Fragment>
  );
};

export default PlatformProducerWithPlatformMerchantOrderDetails;
